import type { Offer } from "./preparation-studio.js";
type Visibility = Offer["priceVisibility"];
// Presentation never rewrites the two established non-disclosure policies.
export function displayedPriceChoice(visibility: Visibility, pendingDisclosure: boolean): "inform" | "withhold" {
  return pendingDisclosure || visibility === "may_disclose" ? "inform" : "withhold";
}
export function nonDisclosurePolicy(visibility: Visibility): Visibility {
  return visibility === "may_disclose" ? "confirm_before_disclose" : visibility;
}
